import React, { useState, useEffect, useRef, Fragment } from "react";
import { useNavigate } from "react-router-dom";

import GaugeComponent from "react-gauge-component";
import { Grid as GridLoading } from "react-loader-spinner";
import html2canvas from "html2canvas";
import SlotCounter from "react-slot-counter";
import { TypeAnimation } from "react-type-animation";
import "../assets/styles/compliance/Complaints.scss";
import { styled } from "@mui/material/styles";
import { theme } from "../theme";
import {
  Chart as ChartJS,
  CategoryScale,
  BarElement,
  Title,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Line } from "react-chartjs-2";
// import ComplaintsSearch from "./compliance/ComplaintsSearch";
import FadeIn from "./compliance/FadeIn";
import { Tooltip as ReactTooltip } from "react-tooltip";

// Import MUI elements
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Skeleton from "@mui/material/Skeleton";
import Select from "@mui/material/Select";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { Grid, Paper } from "@mui/material";

// Import framework to manage datepicker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// Import icons
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SendIcon from "@mui/icons-material/Send";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Item = styled(Paper)(({ theme }) => ({
  padding: 10,
}));

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 850,
  height: 600,
  bgcolor: "background.paper",
  border: "1px solid #000",
  p: 4,
  overflow: "scroll",
  display: "block",
};

const ImageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: 800,
  bgcolor: "background.paper",
  border: "1px solid #000",
  p: 4,
  overflow: "scroll",
  display: "block",
  padding: 0,
};

const L1Categories = [
  {
    id: "1",
    displayName: "Fees",
    slug: "fees",
    resolution_rate_percent_change: -35,
  },
  {
    id: "2",
    displayName: "Fraud / Unauthorized Activity",
    slug: "fraud_unauthorized_activity",
    resolution_rate_percent_change: 14,
  },
  {
    id: "3",
    displayName: "Employee Behavior",
    slug: "employee_behavior",
    resolution_rate_percent_change: 7,
  },
  {
    id: "4",
    displayName: "Digital",
    slug: "digital",
    resolution_rate_percent_change: 3,
  },
];

const hardCodedAlertTextResult = {
  complaints_alerts: {
    alerts: [
      "Complaints about Fees have increased by 35% in the last week.",
      "There were 124 complaints which were escalated this week, a 21% increase from last week",
    ],
    complaint_type: ["Fees", "Fees"],
  },
  message: "",
  status: 1,
};

const MatricsDataFrontCard = ({ mode, title, percentage }: any) => {
  return (
    <Item
      data-tooltip-id='complaints-tooltip'
      className='zoom'
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        backgroundColor: "#f9f9f9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        cursor: "pointer",
        background:
          mode === "dark" ? "#747480 !important" : "#f0f0f0 !important",
      }}
    >
      <div className='compliance-group-box dissatisfied-metric complaints_item'>
        <div className='complaints_grid_wrapper'>
          <div
            style={{ alignItems: "center" }}
            className='comp-no-radio-label complaints-metric'
          >
            <span className='title'>{title}</span>
          </div>
          <div className='exec-radio-values compliance-metrics-values complaints-met-val'>
            <div className='compliance-sidebar-number complaints-left-number'>
              <SlotCounter
                value={percentage ? parseFloat(percentage).toFixed(0) : 0}
              />
              {/* <span className='percentage-sign'>%</span> */}
            </div>
            {/* <span className='exec-sidebar-percentage complaints-percentage-change'>
              {percentageChange !== null ? (
                <span
                  className={`${
                    parseFloat(percentageChange) === 0
                      ? "no-arrow"
                      : parseFloat(percentageChange) < 0
                      ? "red-arrow"
                      : "green-arrow"
                  } number`}
                >
                  {parseFloat(percentageChange) === 0
                    ? "00.0%"
                    : (parseFloat(percentageChange) < 0 ? "" : "") +
                      Math.abs(parseFloat(percentageChange)).toFixed(1) +
                      "%"}
                  {parseFloat(percentageChange) === 0
                    ? "⬅"
                    : parseFloat(percentageChange) < 0
                    ? "⬇"
                    : "⬆"}
                </span>
              ) : (
                <span className='no-arrow number'>0.0%⬅</span>
              )}
            </span> */}
          </div>
        </div>
      </div>
    </Item>
  );
};

const MatricsDataBackCard = ({ mode, snippets }: any) => {
  return (
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backfaceVisibility: "hidden",
        backgroundColor: mode === "dark" ? "#2E2E38" : "#d3d3d3",
        transform: "rotateX(180deg)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "auto", // Add overflow to handle long content
      }}
    >
      {snippets && snippets.length > 0 ? (
        snippets.map((snippet: string, index: number) => (
          <p key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
            "{snippet}"
          </p>
        ))
      ) : (
        <span>No Snippets Available</span>
      )}
    </Box>
  );
};

function Complaints({ parentToChild }: { parentToChild: any }) {
  let navigate = useNavigate();

  const outsideClickRef = useRef<HTMLDivElement | null>(null);
  const { mode } = parentToChild;

  const [complaintTypesData, setComplaintTypesData] = useState<any>(null);
  const [complaintStatsData, setComplaintStatsData] = useState<any>(null);
  const [complaintTotalData, setComplaintTotalData] = useState<any>(null);
  const [lineChartData, setLineChartData] = useState<any>(null);
  const [barChartData, setBarChartData] = useState<any>(null);
  const [keyMetricsData, setKeyMetricsData] = useState<any>(null);

  // const [numbersAsInt, setNumbersAsInt] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [alertData, setAlertData] = useState<any>();
  const [alertText, setAlertText] = useState<string[]>([]);
  const [alertLabel, setAlertLabel] = useState<string[]>([]);

  // Add state for selected option and start date
  const [selectedOption, setSelectedOption] = useState<string>("Last 7 days");
  const [endDate, setEndDate] = useState<dayjs.Dayjs>(dayjs("2024-01-31"));
  const [startDate, setStartDate] = useState<dayjs.Dayjs>(dayjs("2024-01-25"));

  // Variables for sending a report
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [subject, setSubject] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [frequency, setFrequency] = useState<string>("Daily");
  const [recurrences, setRecurrences] = useState<string>("1");
  const [rangeStartDate, setRangeStartDate] = useState<dayjs.Dayjs>(dayjs());
  const [rangeEndDate, setRangeEndDate] = useState<dayjs.Dayjs>(dayjs());
  const Today = dayjs();

  const [selectedComplaintType, setSelectedComplaintType] =
    useState<string>("All");
  const [selectedComplaintTheme, setSelectedComplaintTheme] =
    useState<string>("All");
  const [selectedFilter, setSelectedFilter] = useState<string>("All");

  const [clickedLabel, setClickedLabel] = useState(null);
  const [layout, setLayout] = React.useState<string | null>("overview");
  // const [clickedRow, setClickedRow] = useState<number>();

  const [selectedComplaintStatsData, setSelectedSelectedComplaintStatsData] =
    useState<string>("");
  const [concernFlagsData, setConcernFlagsData] = useState<any>(null);

  const [categories, setCategories] = useState<any[]>(L1Categories);
  const [categoriesLoading, setCategoriesLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setCategoriesLoading(true);
      try {
        const formattedStartDate = startDate.toISOString().split("T")[0];
        const formattedEndDate = endDate.toISOString().split("T")[0];

        // Fetch resolution_rates data
        const resolutionRatesResponse = await fetch(
          `/resolution_rates?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const resolutionRatesData = await resolutionRatesResponse.json();

        // Fetch category_counts data
        const categoryCountsResponse = await fetch(
          `/category_counts?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const categoryCountsData = await categoryCountsResponse.json();

        // Update categories with resolution_rates and category_counts
        const updatedCategories = L1Categories.map((category) => ({
          ...category,
          resolution_rate: resolutionRatesData[category.displayName] || 0,
          category_count: categoryCountsData[category.displayName] || 0,
        }));

        setCategories(updatedCategories);
        setCategoriesLoading(false);
      } catch (error) {
        setCategoriesLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [complaintDataLoading, setComplaintDataLoading] = useState(true);
  const [complaintData, setComplaintData] = useState({
    callEscalated: null,
    attritionSignal: null,
    vulnerableCustomer: null,
    discriminationMention: null,
    repeatIssue: null,
    rudeAgent: null,
    longWaitTime: null,
    callMisrouted: null,
  });

  useEffect(() => {
    setComplaintDataLoading(true);
    const fetchComplaintData = async () => {
      try {
        const formattedStartDate = startDate.toISOString().split("T")[0];
        const formattedEndDate = endDate.toISOString().split("T")[0];

        const endpoints = [
          "/call_escalated",
          "/attrition_signal",
          "/vulnerable_customer",
          "/discrimination_mention",
          "/repeat_issue",
          "/rude_agent",
          "/long_wait_time",
          "/call_misrouted",
        ];

        const fetchPromises = endpoints.map((endpoint) =>
          fetch(
            `${endpoint}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
          )
        );

        const responses = await Promise.all(fetchPromises);

        const [
          callEscalated,
          attritionSignal,
          vulnerableCustomer,
          discriminationMention,
          repeatIssue,
          rudeAgent,
          longWaitTime,
          callMisrouted,
        ] = await Promise.all(responses.map((res) => res.json()));

        setComplaintData({
          callEscalated,
          attritionSignal,
          vulnerableCustomer,
          discriminationMention,
          repeatIssue,
          rudeAgent,
          longWaitTime,
          callMisrouted,
        });
        setComplaintDataLoading(false);
      } catch (error) {
        setComplaintDataLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchComplaintData();
  }, [startDate, endDate]);

  const cardData = [
    {
      slug: "operations_signals",
      title: "Operations Signals",
      cards: [
        {
          slug: "callEscalated",
          displayName: "Escalation Risk",
          data: complaintData.callEscalated,
        },
        {
          slug: "attritionSignal",
          displayName: "Customer Attrition",
          data: complaintData.attritionSignal,
        },
        {
          slug: "vulnerableCustomer",
          displayName: "Vulnerable Customer",
          data: complaintData.vulnerableCustomer,
        },
      ],
    },
    {
      slug: "potential_non_compliance_signals",
      title: "Potential Non-Compliance Signals",
      cards: [
        {
          slug: "discriminationMention",
          displayName: "Discrimination",
          data: complaintData.discriminationMention,
        },
        {
          slug: "repeatIssue",
          displayName: "Repeat Issue",
          data: complaintData.repeatIssue,
        },
        {
          slug: "rudeAgent",
          displayName: "Rude Agent",
          data: complaintData.rudeAgent,
        },
      ],
    },
    {
      slug: "customer_experience_signals",
      title: "Customer Experience Signals",
      cards: [
        {
          slug: "longWaitTime",
          displayName: "Long Wait Times",
          data: complaintData.longWaitTime,
        },
        {
          slug: "callMisrouted",
          displayName: "Call Misrouted",
          data: complaintData.callMisrouted,
        },
        {
          slug: "poor_customer_exp",
          displayName: "Poor Customer Exp",
          data: complaintData.callMisrouted,
        },
      ],
    },
  ];

  const handleCardClick = (type: string) => {
    // setSelectedSelectedComplaintStatsData(type);
    setSelectedSelectedComplaintStatsData((prevSelected) => {
      if (prevSelected === type) {
        return "";
      } else {
        return type;
      }
    });
  };

  const handleLayout = (
    event: React.MouseEvent<HTMLElement>,
    newLayout: string | null
  ) => {
    if (newLayout !== null) {
      setLayout(newLayout);
    }
  };

  useEffect(() => {
    if (
      rangeStartDate &&
      rangeEndDate &&
      rangeStartDate.isAfter(rangeEndDate, "day")
    ) {
      setRangeStartDate(rangeEndDate);
    }
  }, [rangeStartDate, rangeEndDate]);

  // Set screenshot data for send report button
  const [screenshot, setScreenshot] = useState<any>();
  const [isImageOpen, setIsImageOpen] = useState<boolean>(false);

  const onButtonClick = async () => {
    const canvas = await html2canvas(document.body);
    const dataUrl = canvas.toDataURL("image/png");

    setScreenshot(dataUrl);
  };

  // Handle click for alerts
  const handleLabelClick = (labelIndex: any) => {
    if (labelIndex === 0) {
      setSelectedComplaintType(alertLabel[0]);
    } else if (labelIndex === 1) {
      setSelectedComplaintType(alertLabel[1]);
    }
    // setClickedRow(undefined);
    setClickedLabel(labelIndex);
  };

  // Updated DatePicker onChange handler
  const handleEndDateChange = (
    selectedOption: string,
    newDate: dayjs.Dayjs
  ) => {
    // Calculate updatedStartDate asynchronously
    setEndDate(newDate);
    let calculatedStartDate;

    setClickedLabel(null);

    const calculateUpdatedStartDate = () => {
      calculatedStartDate = newDate;

      if (selectedOption === "Last 7 days" && newDate instanceof dayjs) {
        calculatedStartDate = newDate.subtract(6, "days");
      } else if (
        selectedOption === "Last 30 days" &&
        newDate instanceof dayjs
      ) {
        calculatedStartDate = newDate.subtract(30, "days");
      } else if (
        selectedOption === "Last 60 days" &&
        newDate instanceof dayjs
      ) {
        calculatedStartDate = newDate.subtract(60, "days");
      }
      setStartDate(calculatedStartDate);
    };
    calculateUpdatedStartDate();
  };

  // Get alerts data via proxy
  useEffect(() => {
    setIsLoading(true);
    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];
    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaints_alerts?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        // const result = await response.json();
        const result = hardCodedAlertTextResult;
        setAlertData(result);
        setAlertText([
          result.complaints_alerts.alerts[0],
          result.complaints_alerts.alerts[1],
        ]);
        setAlertLabel([
          result.complaints_alerts.complaint_type[0],
          result.complaints_alerts.complaint_type[1],
        ]);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [selectedOption, startDate, endDate]);

  const [analysisData, setAnalysisData] = useState<any>(null);
  const [isAnalysisLoading, setIsAnalysisLoading] = useState<boolean>(true);

  // Get complaints analysis/insights data via proxy
  useEffect(() => {
    setIsAnalysisLoading(true);
    let controller = new AbortController();
    let signal = controller.signal;

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      let formattedComplaintTheme = selectedComplaintTheme;
      if (selectedComplaintTheme === "All") {
        formattedComplaintTheme = "";
      }

      let formattedComplaintType = selectedComplaintType;
      if (selectedComplaintType === "All") {
        formattedComplaintType = "";
      }

      try {
        const response = await fetch(
          `/complaints_insights?complaint_theme=${formattedComplaintTheme}&complaint_type=${formattedComplaintType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`,
          { signal }
        );
        const result = await response.json();
        setAnalysisData(result);
        setIsAnalysisLoading(false);
      } catch (error: any) {
        if (error.name === "AbortError") {
          console.log("Request aborted");
        } else {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
      controller = new AbortController();
    };
  }, [selectedComplaintTheme, selectedComplaintType, startDate, endDate]);

  // Get complaint types data
  useEffect(() => {
    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaints_pillar_stats?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();
        setComplaintTypesData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [startDate, endDate]);

  // Get complaint themes data
  // useEffect(() => {
  //     const formattedStartDate = startDate.toISOString().split('T')[0];
  //     const formattedEndDate = endDate.toISOString().split('T')[0];

  //     const fetchData = async () => {
  //         try {
  //             const response = await fetch(`/complaints_theme_stats?start_date=${formattedStartDate}&end_date=${formattedEndDate}`);
  //             const result = await response.json();
  //             // console.log(result)
  //             // setComplaintThemesData(result);
  //         } catch (error) {
  //             console.error('Error fetching data:', error);
  //         }
  //     };
  //     fetchData();
  // }, [startDate, endDate]);

  // Get dissatisfaction stats data
  useEffect(() => {
    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaints_dissatisfaction_events_stats?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();
        setComplaintStatsData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [startDate, endDate]);

  // Get gauge total number
  useEffect(() => {
    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/total_complaints?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();
        setComplaintTotalData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [startDate, endDate]);

  // Get key metrics data
  useEffect(() => {
    let formattedComplaintTheme = selectedComplaintTheme;
    if (selectedComplaintTheme === "All") {
      formattedComplaintTheme = "";
    }

    let formattedComplaintType = selectedComplaintType;
    if (selectedComplaintType === "All") {
      formattedComplaintType = "";
    }

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/sentiment_resolution_scores?complaint_theme=${formattedComplaintTheme}&complaint_type=${formattedComplaintType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();
        setKeyMetricsData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectedComplaintTheme, selectedComplaintType, startDate, endDate]);

  // Get complaints horizontal bar chart data
  useEffect(() => {
    let formattedComplaintTheme = selectedComplaintTheme;
    if (selectedComplaintTheme === "All") {
      formattedComplaintTheme = "";
    }

    let formattedComplaintType = selectedComplaintType;
    if (selectedComplaintType === "All") {
      formattedComplaintType = "";
    }

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaints_product_chart?complaint_theme=${formattedComplaintTheme}&complaint_type=${formattedComplaintType}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();

        const countArray = result.map((item: any) =>
          parseFloat(item.percentage_of_total_complaints)
        );
        const prodArray = result.map((item: any) => item.product);

        setBarChartData([countArray, prodArray]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectedComplaintTheme, selectedComplaintType, startDate, endDate]);

  // Get complaints concern flags chart data
  useEffect(() => {
    let formattedComplaintTheme = selectedComplaintTheme;
    if (selectedComplaintTheme === "All") {
      formattedComplaintTheme = "";
    }

    let formattedComplaintType = selectedComplaintType;
    if (selectedComplaintType === "All") {
      formattedComplaintType = "";
    }

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaints_concern_flags_chart?start_date=${formattedStartDate}&end_date=${formattedEndDate}&complaint_theme=${formattedComplaintTheme}&complaint_type=${formattedComplaintType}`
        );
        const result = await response.json();

        const flagsArray = result.map((item: any) => item.concern_flag);
        const percentageArray = result.map((item: any) =>
          parseFloat(item.percentage).toFixed(1)
        );

        setConcernFlagsData([flagsArray, percentageArray]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [startDate, endDate, selectedComplaintType, selectedComplaintTheme]);

  useEffect(() => {
    if (
      selectedComplaintTheme === "Unauthorized changes to account" ||
      selectedComplaintTheme === "Hidden fees or charges" ||
      selectedComplaintTheme === "Unauthorized account opening"
    ) {
      setSelectedComplaintType("Sales Practice");
    } else if (
      selectedComplaintTheme === "Unauthorized transaction" ||
      selectedComplaintTheme ===
        "Card information leaked due to vendor account hacked" ||
      selectedComplaintTheme === "Card lost/stolen"
    ) {
      setSelectedComplaintType("Fraud");
    } else if (
      selectedComplaintTheme === "Late fee" ||
      selectedComplaintTheme === "Annual fee" ||
      selectedComplaintTheme === "Account maintenance fee"
    ) {
      setSelectedComplaintType("Fee/Charge");
    } else if (
      selectedComplaintTheme === "Account login issue" ||
      selectedComplaintTheme === "Transaction issue" ||
      selectedComplaintTheme === "Online/mobile banking inactivity"
    ) {
      setSelectedComplaintType("Digital or Product Issue");
    }
  }, [selectedComplaintTheme]);

  useEffect(() => {
    if (selectedComplaintType === "All") {
      setSelectedComplaintTheme("All");
    } else if (
      selectedComplaintType === "Sales Practice" &&
      selectedComplaintTheme !== "Unauthorized changes to account" &&
      selectedComplaintTheme !== "Hidden fees or charges" &&
      selectedComplaintTheme !== "Unauthorized account opening"
    ) {
      setSelectedComplaintTheme("All");
    } else if (
      selectedComplaintType === "Fraud" &&
      selectedComplaintTheme !== "Unauthorized transaction" &&
      selectedComplaintTheme !==
        "Card information leaked due to vendor account hacked" &&
      selectedComplaintTheme !== "Card lost/stolen"
    ) {
      setSelectedComplaintTheme("All");
    } else if (
      selectedComplaintType === "Fee/Charge" &&
      selectedComplaintTheme !== "Late fee" &&
      selectedComplaintTheme !== "Annual fee" &&
      selectedComplaintTheme !== "Account maintenance fee"
    ) {
      setSelectedComplaintTheme("All");
    } else if (
      selectedComplaintType === "Digital or Product Issue" &&
      selectedComplaintTheme !== "Account login issue" &&
      selectedComplaintTheme !== "Transaction issue" &&
      selectedComplaintTheme !== "Online/mobile banking inactivity"
    ) {
      setSelectedComplaintTheme("All");
    }
    // eslint-disable-next-line
  }, [selectedComplaintType]);

  // Get complaints line chart data
  useEffect(() => {
    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/complaint_volume_by_l1_and_date?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );
        const result = await response.json();

        const complaintsCountArray = result.map((item: any) =>
          parseFloat(item.complaint_count)
        );
        const l1CategoryArray = result.map((item: any) => item.l1_category);
        const dateArray = result.map((item: any) => {
          const date = new Date(item.date);
          const day = ("0" + date.getDate()).slice(-2);
          const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const month = monthNames[date.getMonth()];
          return `${day}-${month}`;
        });

        setLineChartData([l1CategoryArray, complaintsCountArray, dateArray]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectedFilter, startDate, endDate]);

  // Line chart options
  const options4 = {
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "x" as const,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    plugins: {
      datalabels: {
        display: false,
        color: mode === "light" ? "black" : "white",
        zIndex: 5,
        labels: {
          value: {
            color: mode === "light" ? "black" : "white",
          },
        },
        formatter: function (context: any) {
          // Remove references to "Resolution Rate" and "Sentiment Score"
          let format = "";
          if (selectedFilter !== "All") {
            format = context.toFixed(0); // Format values as integers for all filters
          }
          return format;
        },
      },
      legend: {
        display: false,
        labels: {
          boxWidth: 10,
          color: mode === "light" ? "#797979" : "#b3b3b3",
        },
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
        ticks: {
          color: mode === "light" ? "#797979" : "#b3b3b3",
        },
        grid: {
          color: mode === "light" ? "#e4e4e4" : "#5e5e5e",
        },
      },
      y: {
        title: {
          display: false,
        },
        ticks: {
          color: mode === "light" ? "#797979" : "#b3b3b3",
        },
        grid: {
          color: mode === "light" ? "#e4e4e4" : "#5e5e5e",
        },
      },
    },
  };

  // Combined function to get both filtered data and labels
  const getFilteredDataAndLabels = () => {
    // Check if lineChartData exists and is valid
    if (
      !lineChartData ||
      !Array.isArray(lineChartData) ||
      lineChartData.length < 3
    ) {
      return { data: [], labels: [] }; // Return empty arrays if there's no valid data
    }

    const [l1CategoryArray, complaintsCountArray, dateArray] = lineChartData;

    // If 'All' is selected, aggregate data by date
    if (selectedFilter === "All") {
      const aggregatedData: { [key: string]: number } = {};

      // Aggregate counts by date
      for (let i = 0; i < dateArray.length; i++) {
        const date = dateArray[i];
        const count = complaintsCountArray[i];

        if (!aggregatedData[date]) {
          aggregatedData[date] = 0;
        }
        aggregatedData[date] += count;
      }

      // Convert aggregated data back to arrays
      const aggregatedDates = Object.keys(aggregatedData).slice(0, 7); // Get first 7 dates
      const aggregatedCounts = aggregatedDates.map(
        (date) => aggregatedData[date]
      );

      return {
        data: aggregatedCounts,
        labels: aggregatedDates,
      };
    }

    // Filter data and labels based on the selected filter
    const filteredData = [];
    const filteredLabels = [];

    for (let i = 0; i < l1CategoryArray.length; i++) {
      if (l1CategoryArray[i] === selectedFilter) {
        filteredData.push(complaintsCountArray[i]);
        filteredLabels.push(dateArray[i]);

        // Stop collecting after 7 entries
        if (filteredData.length >= 7) {
          break;
        }
      }
    }

    // Return the filtered data and labels
    return {
      data: filteredData,
      labels: filteredLabels,
    };
  };

  // Extract data and labels from the combined function
  const { data: filteredData, labels: filteredLabels } =
    getFilteredDataAndLabels();

  // Use the filtered data and labels in your chart configuration
  const data4 = {
    labels: filteredLabels, // Use the filtered labels
    datasets: [
      {
        label: selectedFilter,
        data: filteredData, // Use the filtered data
        borderColor: theme.colors.primary,
        backgroundColor: "#2e2e38",
      },
    ],
  };

  const handleSendReport = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openImage = () => {
    setIsImageOpen(true);
  };

  const closeImage = () => {
    setIsImageOpen(false);
  };

  const handleReset = () => {
    setSelectedOption("Last 7 days");
    setEndDate(dayjs("2024-01-31"));
    setStartDate(dayjs("2024-01-24"));
    setAlertData(null);
    setAlertText([]);
    setIsLoading(true);
    setClickedLabel(null);
    setLayout("overview");
    setSelectedFilter("Resolution Rate");
    setSelectedComplaintType("All");
    setSelectedComplaintTheme("All");
  };

  // Function to handle clicks outside of the modal
  const handleClickOutside = (event: MouseEvent) => {
    if (
      outsideClickRef.current &&
      !outsideClickRef.current.contains(event.target as Node)
    ) {
      setSelectedSelectedComplaintStatsData("");
    }
  };

  useEffect(() => {
    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <FadeIn transitionDuration={700}>
      <div className='ops-root container'>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FadeIn transitionDuration={700}>
                <Item className='ops-navbar-filters'>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={3} lg={1.5} xl={1.5}>
                        <FormControl fullWidth>
                          <InputLabel id='select-label'>
                            Reference Period
                          </InputLabel>
                          <Select
                            labelId='select-label'
                            id='select'
                            value={selectedOption}
                            onChange={(e) => {
                              setSelectedOption(e.target.value);
                              handleEndDateChange(e.target.value, endDate);
                            }}
                          >
                            <MenuItem value='Last 7 days'>Last 7 days</MenuItem>
                            <MenuItem value='Last 30 days'>
                              Last 30 days
                            </MenuItem>
                            <MenuItem value='Last 60 days'>
                              Last 60 days
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={1.5} xl={1.5}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale='en'
                        >
                          <div>
                            <DatePicker
                              defaultValue={dayjs("2024-01-31")}
                              label='Report Date'
                              value={endDate}
                              onChange={(e) => {
                                handleEndDateChange(
                                  selectedOption,
                                  e || dayjs("2024-01-31")
                                );
                              }}
                            />
                          </div>
                        </LocalizationProvider>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={2} lg={1.5} xl={1.5}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-call-center">Call Center</InputLabel>
                                                <Select
                                                    labelId="select-cc-label"
                                                    id="select-cc"
                                                    value={selectedCallCenter}
                                                    onChange={(e) => {
                                                        setSelectedCallCenter(e.target.value);
                                                        handleCallCenterChange(e.target.value, selectedCallCenter);
                                                    }}
                                                >
                                                    <MenuItem value="CC001">Davis-Morgan Center</MenuItem>
                                                    <MenuItem value="CC002">Dixon, Johnson and Dickerson Center</MenuItem>
                                                    <MenuItem value="CC003">Davis-Ross Center</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid> */}
                      <Grid item xs={12} sm={12} md={5} lg={2.8} xl={2.8}>
                        <div className='exec-buttons'>
                          <Button
                            className='ops-nav-btn exec-nav-btn'
                            variant='contained'
                            endIcon={<RestartAltIcon />}
                            onClick={handleReset}
                          >
                            Reset Filters
                          </Button>
                          <Button
                            className='ops-nav-btn exec-nav-btn'
                            variant='contained'
                            endIcon={<SendIcon />}
                            onClick={() => {
                              onButtonClick();
                              openModal();
                            }}
                          >
                            Send Report
                          </Button>
                        </div>
                      </Grid>

                      <Grid
                        className='switch-toggle'
                        item
                        xs={12}
                        sm={12}
                        md={6.2}
                        lg={6.2}
                        xl={6.2}
                      >
                        <ToggleButtonGroup
                          value={layout}
                          exclusive
                          onChange={handleLayout}
                          aria-label='layout toggle button group'
                          className='layout-toggle'
                        >
                          <ToggleButton
                            value='overview'
                            aria-label='overview layout'
                          >
                            <PeopleIcon />
                            <span>Executive</span>
                          </ToggleButton>
                          <ToggleButton
                            onClick={() =>
                              navigate("/complaints/detailed?callReason=fees")
                            }
                            value='analysis'
                            aria-label='analysis layout'
                          >
                            <BarChartIcon />
                            <span>Analysis</span>
                          </ToggleButton>
                          {/* <ToggleButton value="agent" aria-label="agent layout">
                                                    <PersonIcon /><span>Agent</span>
                                                </ToggleButton> */}
                        </ToggleButtonGroup>
                      </Grid>

                      <Modal
                        className='ops-send-modal modal-global'
                        open={isModalOpen}
                        onClose={closeModal}
                        aria-labelledby='modal-modal-title'
                        aria-describedby='modal-modal-description'
                      >
                        <Box className='modal-style' sx={ModalStyle}>
                          <h3>
                            <SendIcon /> Report Form
                          </h3>
                          <div>
                            <TextField
                              label='Subject'
                              variant='outlined'
                              fullWidth
                              value={subject}
                              onChange={(e) => setSubject(e.target.value)}
                              margin='normal'
                            />
                            <TextField
                              label='Email'
                              variant='outlined'
                              fullWidth
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              margin='normal'
                            />
                            <TextField
                              label='Additional Comments'
                              variant='outlined'
                              fullWidth
                              multiline
                              rows={4}
                              value={comments}
                              onChange={(e) => setComments(e.target.value)}
                              margin='normal'
                            />
                            <FormControl
                              fullWidth
                              className='send-report-dropdown'
                            >
                              <InputLabel id='select-label'>
                                Report Frequency
                              </InputLabel>
                              <Select
                                labelId='select-label'
                                id='select'
                                value={frequency}
                                onChange={(e) => {
                                  setFrequency(e.target.value);
                                }}
                              >
                                <MenuItem value='Daily'>Daily</MenuItem>
                                <MenuItem value='Weekly'>Weekly</MenuItem>
                                <MenuItem value='Monthly'>Monthly</MenuItem>
                              </Select>
                            </FormControl>
                            <TextField
                              label='Num of Recurrences'
                              variant='outlined'
                              fullWidth
                              type='number'
                              value={recurrences}
                              onChange={(e) => {
                                const value = parseInt(e.target.value);
                                if (
                                  !isNaN(value) &&
                                  value >= 0 &&
                                  value <= 365
                                ) {
                                  setRecurrences(value.toString());
                                } else if (e.target.value === "") {
                                  setRecurrences("");
                                }
                              }}
                              margin='normal'
                              inputProps={{ inputMode: "numeric", max: 365 }}
                            />
                            <p className='text-dark-mode'>Recurrence Range:</p>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale='en'
                            >
                              <div className='send-report-datepickers'>
                                <DatePicker
                                  className='exec-date-picker'
                                  label='Start'
                                  value={rangeStartDate}
                                  onChange={(date) => {
                                    if (date && date.isBefore(Today, "day")) {
                                      setRangeStartDate(Today);
                                    } else {
                                      setRangeStartDate(date || Today);
                                    }
                                  }}
                                />
                                <span className='text-dark-mode'> to </span>
                                <DatePicker
                                  className='exec-date-picker'
                                  label='End'
                                  value={rangeEndDate}
                                  onChange={(date) => {
                                    if (date && date.isBefore(Today, "day")) {
                                      setRangeEndDate(Today);
                                    } else if (
                                      rangeStartDate &&
                                      date &&
                                      date.isBefore(rangeStartDate, "day")
                                    ) {
                                      setRangeEndDate(rangeStartDate);
                                    } else {
                                      setRangeEndDate(date || Today);
                                    }
                                  }}
                                />
                              </div>
                            </LocalizationProvider>
                            {screenshot && (
                              <div className='send-report-attachment'>
                                <p>Attachment:</p>
                                <img
                                  src={screenshot}
                                  alt='Screenshot'
                                  onClick={openImage}
                                />
                              </div>
                            )}
                          </div>
                          <div>
                            <Button
                              className='ops-send-btn'
                              variant='contained'
                              onClick={handleSendReport}
                            >
                              Send
                            </Button>
                          </div>
                        </Box>
                      </Modal>
                      <Modal
                        className='exec-send-modal modal-global'
                        open={isImageOpen}
                        onClose={closeImage}
                        aria-labelledby='modal-modal-title'
                        aria-describedby='modal-modal-description'
                      >
                        <Box sx={ImageStyle}>
                          <div className='magnified-content'>
                            <img src={screenshot} alt='Magnified Screenshot' />
                          </div>
                        </Box>
                      </Modal>
                    </Grid>
                  </Box>
                </Item>
              </FadeIn>
            </Grid>
            <Grid item xs={12}>
              <Item className='ops-navbar compliance-header'>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    {isLoading ||
                    (alertData && alertData.complaints_alerts === "") ? (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        className='exec-alert'
                      >
                        <Skeleton height='70px' width='100%' />
                        <span className='centered-text'>
                          <GridLoading
                            visible={true}
                            height='15'
                            width='15'
                            color={mode === "dark" ? "white" : "black"}
                            ariaLabel='grid-loading'
                            radius='12.5'
                            wrapperStyle={{}}
                            wrapperClass='grid-wrapper'
                          />
                          AI is analyzing key alerts...
                        </span>
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        className={`exec-alert ${
                          clickedLabel === 0 ? "clicked" : "not-clicked"
                        }`}
                        onClick={() =>
                          navigate("/complaints/detailed?callReason=fees")
                        }
                        // onClick={() => handleLabelClick(0)}
                      >
                        <div className='alert alert--info'>
                          {mode === "dark" ? (
                            <AutoAwesomeIcon />
                          ) : (
                            <span className='ai-driven-light'>
                              <AutoAwesomeIcon />
                            </span>
                          )}
                          <div className='content'>
                            <div className='body'>
                              <TypeAnimation
                                sequence={[
                                  `${
                                    alertText[0] !== undefined
                                      ? alertText[0]
                                      : "No data available"
                                  }`,
                                ]}
                                speed={{
                                  type: "keyStrokeDelayInMs",
                                  value: 10,
                                }}
                                cursor={false}
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                    )}
                    {isLoading ||
                    (alertData && alertData.complaints_alerts === "") ? (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        className='exec-alert'
                      >
                        <Skeleton height='70px' width='100%' />
                        <span className='centered-text'>
                          <GridLoading
                            visible={true}
                            height='15'
                            width='15'
                            color={mode === "dark" ? "white" : "black"}
                            ariaLabel='grid-loading'
                            radius='12.5'
                            wrapperStyle={{}}
                            wrapperClass='grid-wrapper'
                          />
                          AI is analyzing key alerts...
                        </span>
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        className={`exec-alert ${
                          clickedLabel === 1 ? "clicked" : "not-clicked"
                        }`}
                        onClick={() =>
                          navigate("/complaints/detailed?callReason=fees")
                        }
                        // onClick={() => handleLabelClick(1)}
                      >
                        <div className='alert alert--info'>
                          {mode === "dark" ? (
                            <AutoAwesomeIcon />
                          ) : (
                            <span className='ai-driven-light'>
                              <AutoAwesomeIcon />
                            </span>
                          )}
                          <div className='content'>
                            <div className='body'>
                              <TypeAnimation
                                sequence={[
                                  `${
                                    alertText[1] !== undefined
                                      ? alertText[1]
                                      : "No data available"
                                  }`,
                                ]}
                                speed={{
                                  type: "keyStrokeDelayInMs",
                                  value: 10,
                                }}
                                cursor={false}
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Item>
            </Grid>
          </Grid>

          <FadeIn transitionDuration={700}>
            <Grid className='ops-container-wrapper' container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                <Item className='compliance-items-wrapper'>
                  <Grid item xs={12}>
                    <div className='compliance-items-wrapper complaints-right-area complaints-left-side'>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Grid container spacing={2}>
                            <Grid
                              className='gauge-chart-grid'
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={5.5}
                              xl={5.5}
                            >
                              <div className='gauge-chart-wrapper'>
                                <h3>Complaints Handled</h3>
                                <GaugeComponent
                                  id='gauge-component1'
                                  value={
                                    complaintTotalData
                                      ? parseInt(
                                          complaintTotalData.total_complaints
                                        )
                                      : 0
                                  }
                                  minValue={0}
                                  maxValue={400}
                                  arc={{
                                    subArcs: [
                                      {
                                        limit: 150,
                                        color: "#70ad47",
                                        showTick: true,
                                        tooltip: { text: "Good" },
                                      },
                                      {
                                        limit: 250,
                                        color: "#ffe600",
                                        showTick: true,
                                        tooltip: { text: "Fine" },
                                      },
                                      {
                                        limit: 350,
                                        color: "red",
                                        showTick: true,
                                        tooltip: { text: "High" },
                                      },
                                    ],
                                  }}
                                  labels={{
                                    valueLabel: {
                                      formatTextValue: (value: number) =>
                                        `${value}`,
                                      matchColorWithArc: false,
                                      style: {
                                        fontSize: "50px",
                                        fontFamily: theme.fonts.secondary,
                                        fill:
                                          mode === "light" ? "black" : "white",
                                        textShadow: "none",
                                        whiteSpace: "pre", // Set whiteSpace to "pre-line" or "pre-wrap"
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </Grid>
                            <Grid
                              className='complaint-types-wrapper'
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6.5}
                              xl={6.5}
                              style={{ paddingLeft: "0px" }}
                            >
                              <div className='complaint-chart-wrapper'>
                                <div className='complaint-chart-header-wrapper'>
                                  <h3>Complaint Volume</h3>
                                  <FormControl
                                    variant='standard'
                                    sx={{ m: 1, minWidth: 120 }}
                                  >
                                    <Select
                                      labelId='demo-simple-select-standard-label'
                                      id='demo-simple-select-standard'
                                      value={selectedFilter}
                                      onChange={(e) => {
                                        setSelectedFilter(e.target.value);
                                      }}
                                    >
                                      <MenuItem value='All'>All</MenuItem>
                                      {L1Categories.map((item: any) => (
                                        <MenuItem
                                          key={item.displayName}
                                          value={item.displayName}
                                        >
                                          {item?.displayName}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className='complaint-chart-2'>
                                  <Line
                                    options={options4}
                                    data={data4}
                                    plugins={[ChartDataLabels]}
                                  />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          className='divider-padding'
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                        >
                          <Divider />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Grid container spacing={2}>
                            <Grid
                              className='complaints-left'
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  backgroundColor:
                                    mode === "dark" ? "#2E2E38" : "#f0f0f0",
                                  padding: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: "65%",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                >
                                  Complaint Types
                                </Box>
                                <Box
                                  sx={{
                                    width: "12%",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  Calls
                                </Box>
                                <Box
                                  sx={{
                                    width: "12%",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  Resol%
                                </Box>
                                <Box
                                  sx={{
                                    width: "12%",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  Change
                                </Box>
                              </Box>

                              <Grid container direction='column'>
                                {!categoriesLoading &&
                                  categories &&
                                  categories.length > 0 &&
                                  categories.map(
                                    (category: any, index: number) => (
                                      <Grid
                                        key={index}
                                        container
                                        item
                                        sx={{
                                          cursor: "pointer",
                                          background:
                                            mode === "dark"
                                              ? "#747480"
                                              : "#f9f9f9",
                                          marginBottom: "10px",
                                          borderRadius: "8px",
                                          boxShadow:
                                            "0px 2px 3px rgba(0, 0, 0, 0.1)",
                                        }}
                                        onClick={() =>
                                          navigate(
                                            `/complaints/detailed?callReason=${category?.slug}`
                                          )
                                        }
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          sm={7.5}
                                          sx={{
                                            padding: "10px",
                                          }}
                                        >
                                          {category.displayName}
                                        </Grid>

                                        <Grid
                                          item
                                          xs={12}
                                          sm={1.5}
                                          sx={{
                                            padding: "10px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {category.category_count}
                                        </Grid>

                                        <Grid
                                          item
                                          xs={12}
                                          sm={1.5}
                                          sx={{
                                            padding: "10px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {parseFloat(
                                            category.resolution_rate
                                          ).toFixed(0)}
                                          %
                                        </Grid>

                                        <Grid
                                          item
                                          xs={12}
                                          sm={1.5}
                                          sx={{
                                            padding: "10px",
                                            textAlign: "center",
                                            color:
                                              category?.slug === "fees"
                                                ? "red"
                                                : "green",
                                          }}
                                        >
                                          {/* {category?.change}% */}
                                          <span className='complaints-metrics-percentage-change'>
                                            {category.resolution_rate_percent_change !==
                                            null ? (
                                              <span
                                                className={`${
                                                  parseFloat(
                                                    category.resolution_rate_percent_change
                                                  ) === 0
                                                    ? "no-arrow"
                                                    : parseFloat(
                                                        category.resolution_rate_percent_change
                                                      ) < 0
                                                    ? "red-arrow"
                                                    : "green-arrow"
                                                } number`}
                                              >
                                                {parseFloat(
                                                  category.resolution_rate_percent_change
                                                ) === 0
                                                  ? "00.0%"
                                                  : (parseFloat(
                                                      category.resolution_rate_percent_change
                                                    ) < 0
                                                      ? ""
                                                      : "") +
                                                    Math.abs(
                                                      parseFloat(
                                                        category.resolution_rate_percent_change
                                                      )
                                                    ).toFixed(1) +
                                                    "%"}
                                                {parseFloat(
                                                  category.resolution_rate_percent_change
                                                ) === 0
                                                  ? "⬅"
                                                  : parseFloat(
                                                      category.resolution_rate_percent_change
                                                    ) < 0
                                                  ? "⬆"
                                                  : "⬇"}
                                              </span>
                                            ) : (
                                              <span className='no-arrow number'>
                                                0.0%⬅
                                              </span>
                                            )}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    )
                                  )}
                              </Grid>

                              {/* Fallback Skeleton Loader */}
                              {categoriesLoading && (
                                <div className='complaints-table-skeleton-wrapper'>
                                  <Skeleton height='40px' width='100%' />
                                  <Skeleton height='40px' width='100%' />
                                  <Skeleton height='40px' width='100%' />
                                  <Skeleton height='40px' width='100%' />
                                </div>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Item>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                <Item
                  ref={outsideClickRef}
                  sx={{ height: "100%", padding: "20px" }}
                >
                  <Grid
                    container
                    sx={{ height: "100%" }}
                    spacing={4}
                    justifyContent='center'
                    alignItems='center'
                  >
                    {complaintDataLoading ? (
                      Array(9)
                        .fill(0)
                        .map((_, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <Item
                              sx={{
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "0px",
                              }}
                            >
                              <Skeleton
                                variant='rectangular'
                                width='100%'
                                height='100%'
                                animation='wave'
                              />
                            </Item>
                          </Grid>
                        ))
                    ) : (
                      <>
                        {cardData.map((item) => (
                          <Fragment key={item.slug}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              style={{
                                paddingTop: "20px",
                              }}
                            >
                              <div className='complaints-stats-data-header'>
                                {item.title}
                              </div>
                            </Grid>
                            {item?.cards &&
                              item?.cards.map(
                                (card: any, cardIndex: number) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={card.slug}
                                    onClick={() => handleCardClick(card.slug)}
                                    style={{
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        perspective: "1000px", // Perspective for the 3D effect
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: "100%",
                                          height: "170px",
                                          transformStyle: "preserve-3d",
                                          transition: "transform 0.6s",
                                          transform:
                                            selectedComplaintStatsData ===
                                            card.slug
                                              ? "rotateX(180deg)"
                                              : "rotateX(0deg)",
                                          position: "relative",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {/* Front Side */}
                                        <MatricsDataFrontCard
                                          mode={mode}
                                          title={card?.displayName}
                                          percentage={card?.data?.count || 0}
                                        />
                                        <MatricsDataBackCard
                                          mode={mode}
                                          snippets={card?.data?.snippets || []} // Passing the snippets
                                        />
                                      </Box>
                                    </Box>
                                  </Grid>
                                )
                              )}
                          </Fragment>
                        ))}
                      </>
                    )}
                  </Grid>
                </Item>
              </Grid>
            </Grid>
          </FadeIn>
        </Box>
      </div>
      <ReactTooltip
        id='complaints-tooltip'
        style={{
          borderRadius: "5px",
          ...(mode === "dark" && {
            backgroundColor: "#f5f5f5",
            color: "black",
          }),
        }}
        place='bottom'
        content='Select for more'
      />
    </FadeIn>
  );
}

export default Complaints;
